var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.showDisplayOrderOption
    ? _c("label", { staticClass: "d-flex align-items-center" }, [
        _c(
          "div",
          { staticClass: "dropdown me-2" },
          [
            _c(
              _setup.Button,
              {
                staticClass: "btn-sm dropdown-toggle border",
                attrs: {
                  id: "dropdownMenuDisplayOrder",
                  "aria-expanded": "true",
                  "data-bs-toggle": "dropdown",
                  disabled: _setup.isLoading,
                },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_setup.currentData?.displayOrder) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "dropdown-menu",
                attrs: { "aria-labelledby": "dropdownMenuDisplayOrder" },
              },
              _vm._l(_setup.options, function (i, k) {
                return _c("li", { key: k }, [
                  _c(
                    "button",
                    {
                      staticClass: "dropdown-item",
                      class: { active: i === _setup.currentData?.displayOrder },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _setup.setDisplayOrder(i)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(i) +
                          "\n                "
                      ),
                    ]
                  ),
                ])
              }),
              0
            ),
          ],
          1
        ),
        _vm._v("\n\n    Display order\n"),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }